import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
const wx = require("weixin-js-sdk");

import "./data"

Vue.config.productionTip = false;

Vue.prototype.$isPc = () => {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

const registerWxUrl = "http://jshare.xhby.net/api/signature";

function registerWX(title = "数字图谱赏江苏 十三位市委书记手写寄语", desc = "看各市亮眼成绩单，观看视频有彩蛋") {
  let url = location.href.split("#")[0];
  fetch(registerWxUrl, {
    headers: { "content-type": "application/json; charset=utf-8" },
    method: "POST",
    body: JSON.stringify({ url }),
  }).then(async (res) => {
    const wxData = (await res.json()).data;

    wx.config({
      debug: false,
      appId: wxData.appid,
      timestamp: wxData.timestamp,
      nonceStr: wxData.nonceStr,
      signature: wxData.signature,
      jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"],
    });

    wx.ready(() => {
      let wxData = {
        title,
        desc: "看各市亮眼成绩单，观看视频有彩蛋",
        link: location.href.split("#")[0],
        imgUrl: "https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/video/wx-share.jpg",
      };
      let pengyouquanData = {
        title: "数字图谱赏江苏 十三位市委书记手写寄语",
        desc: "看各市亮眼成绩单，观看视频有彩蛋",
        link: location.href.split("#")[0],
        imgUrl: "https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/video/wx-share.jpg",
      }
      wx.onMenuShareAppMessage(wxData);
      wx.onMenuShareTimeline(pengyouquanData);
    });
  });
};

Vue.prototype.$wx = registerWX;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
